import { render } from "./EditableCell.vue?vue&type=template&id=0822849d&scoped=true"
import script from "./EditableCell.vue?vue&type=script&lang=js"
export * from "./EditableCell.vue?vue&type=script&lang=js"

import "./EditableCell.vue?vue&type=style&index=0&id=0822849d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0822849d"]])

export default __exports__